import React from 'react';
import { Col, Row, Typography } from 'antd';
import styles from './About.module.css';
export const About: React.FC = () => {
  
  return (
    <div className={styles["about"]}>
    <Row justify='center'>
      <Col span={18}>
        <Typography.Title >阳光尔葆<sup>®</sup>&nbsp;患龋风险评估系统</Typography.Title>
      </Col>
    </Row>
    <Row>
      <Col offset={8}>
        <Typography.Paragraph >版本:2.0.1</Typography.Paragraph>
      </Col>
    </Row>
    <Row>
      <Col offset={8}>
        <Typography.Paragraph>技术支持：0752-3160366</Typography.Paragraph>
      </Col>
    </Row>
    <Row>
      <Col offset={8}>
        <Typography.Paragraph><Typography.Text strong>© 2022 广东阳光生物科技有限公司。保留所有权利。</Typography.Text></Typography.Paragraph>
      </Col>
    </Row>
  </div>
  )
};